<script lang="ts" setup>
defineProps({
  titleOne: String,
  titleTwo: String,
  titleThree: String,
  titleFour: String,
  contentOne: String,
  contentTwo: String,
  contentThree: String,
  contentFour: String,
  footerIconLink: String,
  footerIconAlt: String,
  lang: String
})
</script>
<template>
  <div class="flex w-full pt-[40px] lg:pt-0 1440:pl-[40px] 1440:pr-0 lg:px-5">
    <div
      class="flex flex-col w-full lg:flex-row md:gap-[40px] gap-[20px] lg:mx-[0px] ml-[10px] mr-[12px]"
    >
      <div class="flex flex-col justify-start w-full lg:max-w-[250px] md:h-full1">
        <div class="flex justify-start md:justify-center lg:justify-start md:items-center">
          <div class="md:max-w-[22px] max-w-[20px] h-[17px]">
            <img
              class="relative md:h-auto md:w-auto md:static md:top-0 top-1"
              loading="lazy"
              :src="footerIconLink"
              :alt="footerIconAlt"
            />
          </div>

          <div
            v-html="titleOne"
            class="ml-1 text-center lg:text-[15px] 1440:text-lg font-bold leading-[22px]"
          ></div>
        </div>
        <div
          class="mt-[10px] leading-[19px] -tracking-tightest lg:text-[13px] 1440:text-[16px] md:text-center text-start lg:text-start"
          :class="lang === 'ko' ? 'break-keep' : ''"
        >
          {{ contentOne }}
        </div>
      </div>
      <div class="flex flex-col w-full lg:max-w-[250px] lg:h-[75px] md:h-full">
        <div class="flex justify-start md:justify-center lg:justify-start md:items-center">
          <div class="md:max-w-[22px] max-w-[20px] h-[17px]">
            <img
              class="relative md:h-auto md:w-auto md:static md:top-0 top-1"
              loading="lazy"
              :src="footerIconLink"
              :alt="footerIconAlt"
            />
          </div>

          <div
            v-html="titleTwo"
            class="ml-1 lg:text-[15px] 1440:text-lg font-bold leading-[22px]"
          ></div>
        </div>
        <div
          class="mt-[10px] leading-[19px] lg:text-[13px] 1440:text-[16px] -tracking-tightest md:text-center text-start lg:text-start"
          :class="lang === 'ko' ? 'break-keep' : ''"
        >
          {{ contentTwo }}
        </div>
      </div>

      <div class="flex flex-col w-full lg:max-w-[250px] lg:h-[75px] md:h-full">
        <div class="flex justify-start md:justify-center lg:justify-start md:items-center">
          <div class="md:max-w-[22px] max-w-[20px] h-[17px]">
            <img
              class="relative flex-shrink-0 md:h-auto md:w-auto md:static md:top-0 top-1"
              loading="lazy"
              :src="footerIconLink"
              :alt="footerIconAlt"
            />
          </div>

          <div
            v-html="titleThree"
            class="ml-1 lg:text-[15px] 1440:text-lg font-bold leading-[22px]"
          ></div>
        </div>
        <div
          class="mt-[10px] leading-[19px] -tracking-tightest lg:text-[13px] 1440:text-[16px] md:text-center text-start lg:text-start"
          :class="lang === 'ko' ? 'break-keep' : ''"
        >
          {{ contentThree }}
        </div>
      </div>
      <div class="flex flex-col w-full lg:max-w-[250px] lg:h-[75px] md:h-full">
        <div class="flex justify-start md:justify-center lg:justify-start md:items-center">
          <div class="md:max-w-[22px] max-w-[20px] h-[17px]">
            <img
              class="relative md:h-auto md:w-auto md:static md:top-0 top-1"
              loading="lazy"
              :src="footerIconLink"
              :alt="footerIconAlt"
            />
          </div>

          <div
            v-html="titleFour"
            class="ml-1 lg:text-[15px] 1440:text-lg font-bold leading-[22px]"
          ></div>
        </div>
        <div
          class="mt-[10px] leading-[19px] -tracking-tightest lg:text-[13px] 1440:text-[16px] md:text-center text-start lg:text-start"
          :class="lang === 'ko' ? 'break-keep' : ''"
        >
          {{ contentFour }}
        </div>
      </div>
    </div>
  </div>
</template>
